import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogTitle,
    Button,
    Card,
} from '@onward-delivery/design';
import AddShipperModal from './AddShipperModal';
import ShipperRow from './ShipperRow';

/**
 * The carrier's list of shipping partners: Add Shipper, a row per partner, and the delete
 * confirmation. Display only; state and actions come from `useShippersTab`.
 * @param {ReturnType<import('../hooks').useShippersTab>} props
 */
const ShipperList = ({
    partners,
    getSetup,
    shipperLabels,
    loading,
    addingShipper,
    openAddShipper,
    addShipperCallbacks,
    selectShipper,
    resendInvite,
    pendingDelete,
    requestDelete,
    cancelDelete,
    confirmDelete,
}) => (
    <>
        <AddShipperModal open={addingShipper} shipperLabels={shipperLabels} callbacks={addShipperCallbacks} />
        <div className="onward-design">
            <div className="flex flex-col gap-5 px-[max(12.5%,6rem)] py-8">
                <h2 className="text-2xl font-bold text-foreground">Shipping Partners</h2>
                <Card className="overflow-hidden p-0">
                    <div className="px-6 pb-2 pt-6">
                        <Button onClick={openAddShipper}>Add Shipper</Button>
                    </div>
                    {partners.length === 0 ? (
                        <p className="px-6 pb-6 text-muted">No shippers yet.</p>
                    ) : (
                        partners.map((partnership) => (
                            <ShipperRow
                                key={partnership.partnership_id}
                                partnership={partnership}
                                setup={getSetup(partnership.shipper_id)}
                                disabled={loading}
                                onOpen={selectShipper}
                                onResendInvite={resendInvite}
                                onDelete={requestDelete}
                            />
                        ))
                    )}
                </Card>
            </div>
            <AlertDialog open={!!pendingDelete} onOpenChange={(open) => !open && cancelDelete()}>
                <AlertDialogContent>
                    <AlertDialogTitle>Delete shipper?</AlertDialogTitle>
                    <AlertDialogDescription>Are you sure you want to delete this shipper?</AlertDialogDescription>
                    <div className="mt-4 flex justify-end gap-2">
                        <AlertDialogCancel>Cancel</AlertDialogCancel>
                        <AlertDialogAction destructive onClick={confirmDelete}>
                            Delete
                        </AlertDialogAction>
                    </div>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    </>
);

export default ShipperList;
